<template lang="pug">
#articles
  section.section.page-section.container
    spinner(v-if="settings.loading")
    div(v-else)
      .search-block.mobile-padding
        b-field
          b-input(
            v-model="filters.query"
            icon="search"
            placeholder="Search for articles..."
            @input="input"
            @keyup.native.enter="search"
            rounded
          )
        a(v-if="filters.query" @click="clearQuery")
          b-icon.has-text-grey-light(icon="times-circle" size="is-small" pack="fas")
      .no-results(v-if="filters.query && articles.length === 0") No articles match your search
      .columns.is-multiline(v-else)
        .column.is-one-third(
          v-for="article in articles"
          :key="article.id"
        )
          article-list-item(:value="article")
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import ArticleListItem from '@/components/articles/ArticleListItem.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'articles',
  components: {
    ArticleListItem,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      articles: getterTypes.GET_ARTICLES,
    }),
    morePages() {
      if (this.pagination.total === 0) return false;
      return Math.ceil(this.pagination.total / this.pagination.per) > this.pagination.page;
    },
    query() {
      const from = this.pagination.per * (this.pagination.page - 1);
      const today = moment().format('YYYY-MM-DD');
      const payload = {
        from: from >= 0 ? from : 0,
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: today } } },
            ],
          },
        },
        size: this.pagination.per,
        sort: {
          pub_date: 'desc',
        },
      };
      if (this.filters.query) {
        const lowercase = this.filters.query.toLowerCase();
        payload.query.bool.must.push({
          bool: {
            should: [
              { match_phrase_prefix: { title: lowercase } },
              { match_phrase_prefix: { short_desc: lowercase } },
              { match_phrase_prefix: { '_embedded.author.full_name': lowercase } },
            ],
          },
        });
      }
      return payload;
    },
  },
  created() {
    this.settings.loading = true;
    this.getPage(1);
  },
  data() {
    return {
      bottom: false,
      filters: {
        query: null,
      },
      pagination: {
        page: 1,
        per: 9,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    clearQuery() {
      this.filters.query = null;
      this.getPage(1);
    },
    async getPage(page, options) {
      this.pagination.page = page;
      const payload = Object.assign(options || {}, this.query);
      const response = await this.$store.dispatch(actionTypes.DO_GET_ARTICLES, payload);
      console.log(response.hits.total);
      this.pagination.total = response.hits.total;
      this.settings.loading = false;
      this.bottom = false;
    },
    input(val) {
      if (!val) {
        this.getPage(1);
      }
    },
    scrollHandler() {
      const y = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const adjustedHeight = pageHeight - 800;
      const bottomOfPage = visible + y >= adjustedHeight;
      this.bottom = bottomOfPage || adjustedHeight < visible;
    },
    search() {
      this.getPage(1);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  watch: {
    bottom(val) {
      if (val && this.morePages) {
        this.getPage(this.pagination.page + 1, { method: 'append' });
      }
    },
  },
};
</script>

<style lang="scss">
#articles {
  margin-bottom: 5rem;
  .search-block {
    margin: 0 auto 2rem;
    position: relative;
    a {
      position: absolute;
      right: 10px;
      top: 6px;
    }
    .input {
      border: none;
      background-color: #ececec;
    }
    .icon {
      color: $grey-light;
    }
  }
  @media (min-width: $tablet) {
    .search-block {
      max-width: 60%;
    }
  }
}
</style>
